import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import type React from "react";
import type { ClinicianClient } from "../../service/members.service";
import styles from "./clinician-profile.module.scss";

const { Text } = Typography;

interface ClinicianClientsProps {
  clients: ClinicianClient[];
  total: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  loading: boolean;
}

const ClinicianClients: React.FC<ClinicianClientsProps> = ({ clients, total, currentPage, onPageChange, loading }) => {
  const columns: ColumnsType<ClinicianClient> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => <Text strong>{name}</Text>,
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (age: number | null) => <Text>{age || "—"}</Text>,
    },
    {
      title: "Total Notes",
      dataIndex: "total_notes",
      key: "total_notes",
      render: (total: number) => <Text>{total}</Text>,
    },
    {
      title: "Last Note",
      dataIndex: "last_note_created_at",
      key: "last_note_created_at",
      render: (date: string | null) => <Text>{date ? new Date(date).toLocaleDateString() : "—"}</Text>,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={clients}
      loading={loading}
      rowKey="uuid"
      pagination={{
        total,
        current: currentPage,
        pageSize: 50,
        showSizeChanger: false,
        onChange: onPageChange,
      }}
      className={styles.clinicianProfile__table}
    />
  );
};

export default ClinicianClients;
